module.exports = __webpack_public_path__ + "static/img/icon3.6667580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/icon3.png
// module id = cx6F
// module chunks = 44